import React from 'react';
import { useNavigate } from 'react-router-dom';

const LayoutSidebar = ({ isOpen, toggleSidebar, side, currentUser }) => {
  const navigate     = useNavigate();
  const isAdminRole  = currentUser?.role?.toLowerCase() === 'admin';
  const isSuperAdmin = currentUser?.username?.toLowerCase() === 'admin';

  const allPages = [
    { name: 'Dashboard',      page: 'DashboardPanel',    path: '/dashboard'  },
    { name: 'Estudiantes',    page: 'StudentsList',      path: '/estudiantes'},
    { name: 'Punto de Venta', page: 'POS',               path: '/pos'        },
    { name: 'Ventas',         page: 'SalesPage',         path: '/ventas'     },
    { name: 'Productos',      page: 'ProductManagement', path: '/productos'  },
    { name: 'Finanzas',       page: 'FinancesPanel',     path: '/finanzas'   },
    { name: 'Calendario',     page: 'Calendar',          path: '/calendario' },
    { name: 'Maestros',       page: 'TeacherManagement', path: '/maestros'   },
    { name: 'Asistencia',     page: 'AttendancePanel',   path: '/asistencia' },
    { name: 'Pagos',          page: 'PaymentsPanel',     path: '/pagos'      },
    { name: 'Usuarios',       page: 'UserManagement',    path: '/usuarios'   },
    // FIX: Festivales agregado a allPages para que el filtro de permisos lo encuentre
    { name: 'Festivales',     page: 'FestivalesPanel',   path: '/festivales' },
  ];

  const leftNavPages = [
    'ProductManagement',
    'TeacherManagement',
    'AttendancePanel',
    'FinancesPanel',
    'PaymentsPanel',
    'FestivalesPanel', // FIX: string, no objeto
  ];

  const rightNavPages = [
    'POS',
    'SalesPage',
    'StudentsList',
    'Calendar',
    'DashboardPanel',
    'UserManagement',
  ];

  const filteredPages = allPages.filter(p => {
    if (p.page === 'UserManagement') return isSuperAdmin;
    if (p.page === 'DashboardPanel') return true;
    return isAdminRole || (currentUser?.pages || []).includes(p.page) || (currentUser?.pages || []).includes('*');
  });

  const navItems = (side === 'left' ? leftNavPages : rightNavPages)
    .map(id => filteredPages.find(p => p.page === id))
    .filter(Boolean)
    .filter((item, idx, arr) => arr.findIndex(x => x.page === item.page) === idx);

  const handleNavigation = path => {
    navigate(path);
    toggleSidebar(side);
  };

  const handleLogout = () => {
    fetch('/api/logout.php', { method: 'POST', credentials: 'include' })
      .then(() => window.location.reload());
  };

  return (
    <div className={`fixed top-0 ${side === 'left' ? 'left-0' : 'right-0'} h-full bg-white text-black w-64 shadow-lg z-40
      transform ${isOpen ? 'translate-x-0' : side === 'left' ? '-translate-x-full' : 'translate-x-full'}
      transition-transform duration-300 ease-in-out`}
    >
      <div className="p-4 flex justify-between items-center border-b">
        {currentUser && (
          <div className="text-sm">
            <p className="font-semibold">{currentUser.username}</p>
            <p className="text-gray-500 text-xs">{currentUser.academy_name || currentUser.role}</p>
          </div>
        )}
        <button onClick={() => toggleSidebar(side)} className="text-black focus:outline-none">
          <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <nav className="mt-4">
        <ul>
          {navItems.map(item => (
            <li key={item.page} className="mb-1">
              <button
                onClick={() => handleNavigation(item.path)}
                className="block w-full text-left px-6 py-3 text-lg
                  hover:bg-[#961914] hover:text-white transition-colors duration-200"
              >
                {item.name}
              </button>
            </li>
          ))}
          {side === 'right' && (
            <li className="mt-4 border-t pt-2">
              <button
                onClick={handleLogout}
                className="block w-full text-left px-6 py-3 text-lg text-red-600
                  hover:bg-red-50 transition-colors duration-200"
              >
                Cerrar Sesión
              </button>
            </li>
          )}
        </ul>
      </nav>
    </div>
  );
};

export default LayoutSidebar;